<nav [ngClass]="{'sidebar second-sidebar' : true, 'hide-sidebar' : mode == 'filtres'}">
    <ul class="list-unstyled components"
        [stepContent]="filtersStepContent"
        joyrideStep="filtersStep"
        stepPosition="left"
        (next)="currentTab = 'city'; mode = 'filtres'"
        (prev)="drawer && drawerClose.emit()">
        <li>
            <a [ngClass]="{'active': currentTab == 'city'}"
               (click)="openCityTab()">
                <b>
                    <i class="icon search_zone"></i>
                    Localisation
                </b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
                <p class="text-primary">
                    <span *ngFor="let city of cities | slice:0:3; index as icity">
                        {{ city.name }}
                        <ng-container *ngIf="icity < (cities | slice:0:3).length - 1">, </ng-container>
                    </span>
                    <span *ngIf="cities.length > 3"> + {{ cities.length - 3 }} autres villes</span>
                    <span
                        *ngIf="searchForm.get('search_city_params_id').value != '' && searchForm.get('search_city_params_id').value != '0'">
                        <ng-container *ngFor="let s of userSearchsCity">
                            <ng-container *ngIf="s.id == searchForm.get('search_city_params_id').value">
                                {{ s.title }}
                            </ng-container>
                        </ng-container>
                    </span>
                </p>
            </a>
        </li>
        <li>
            <!-- Prix : champs Min/Max directement dans la liste -->
            <div class="price-inline">
                <b><i class="icon search_budget"></i> Prix</b>
                <div class="row g-2">
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Min</mat-label>
                            <input type="number" step="1000" matInput [formControl]="$any(searchForm.get('price_min'))">
                            <span matSuffix> €</span>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>Max</mat-label>
                            <input type="number" step="1000" matInput [formControl]="$any(searchForm.get('price_max'))">
                            <span matSuffix> €</span>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'type'}" (click)="currentTab = 'type';mode = 'filtres'">
                <b><i class="icon search_type"></i> Type de bien</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
                <p>
                    <span class="text-capitalize text-primary" *ngFor="let t of types; index as itypes">
                        <ng-container
                            *ngIf="t != 'commerce-fonddecommerce' && t != 'fondsdecommerce'">{{ t }}</ng-container>
                        <ng-container *ngIf="t == 'fondsdecommerce'"> Fond de commerce</ng-container>
                        <ng-container *ngIf="itypes < types.length - 1">, </ng-container>
                    </span>
                </p>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'square'}" (click)="currentTab = 'square';mode = 'filtres'">
                <b><i class="icon search_square"></i> Surface et pièces</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>

                <p *ngIf="searchForm.get('surface') && filterShow(searchForm.get('surface').value) == 'all'">
                    Entre <span class="text-primary">{{ searchForm.get('surface').value[0] | number }}m²</span> et
                    <span class="text-primary">{{ searchForm.get('surface').value[1] | number }}m²</span>
                </p>
                <p *ngIf="searchForm.get('surface') && filterShow(searchForm.get('surface').value) == 'max'">
                    Moins de <span class="text-primary">{{ searchForm.get('surface').value[1] | number }}m²</span>
                </p>
                <p *ngIf="searchForm.get('surface') && filterShow(searchForm.get('surface').value) == 'min'">
                    <span class="text-primary">{{ searchForm.get('surface').value[0] | number }}m²</span> et plus
                </p>
            </a>
        </li>
        <li
            [stepContent]="filtersTabsContent"
            joyrideStep="filtersTabsStep"
            (prev)="currentTab = 'city'; mode = 'filtres'"
            (next)="currentTab = 'invest'; mode = 'filtres'">
            <a [ngClass]="{'active': currentTab == 'invest'}" (click)="currentTab = 'invest';mode = 'filtres'">
                <b><i class="icon invest"></i> Investissement</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'advance'}" (click)="openAdvanceTab()">
                <b><i class="icon search_advance"></i> Critères avancés</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
            </a>
        </li>
        <li>
            <a [ngClass]="{'active': currentTab == 'text'}" (click)="currentTab = 'text';mode = 'filtres'">
                <b><i class="icon search_keyword"></i> Mots clés</b>
                <i class="fa fa-chevron-right float-right text-primary"></i>
            </a>
        </li>
    </ul>

    <div class="container-fluid filters-actions">
        <div class="d-flex justify-content-between gap-3">
            <button class="btn btn-lg btn-outline" type="button" (click)="resetAllFilters()">
                <i class="fa fa-refresh"></i> Tout effacer
            </button>
            <button class="btn btn-lg" (click)="search()"
                    [stepContent]="filtersValidateContent"
                    (prev)="currentTab = 'advance'; mode = 'filtres'"
                    (next)="drawer && search()"
                    joyrideStep="filtersValidateStep">
                <i class="fa fa-search"></i> Rechercher
            </button>
        </div>
    </div>
</nav>

<div id="content-second-sidebar">

    <div class="container-fluid main-card">
        <div class="row h1_row">
            <div class="col-sm-8 col-11">
                <h1>
                    {{ (this.currentSearch != undefined && this.currentSearch.title !== undefined && this.currentSearch.title !== '' ? 'Votre recherche ' + this.currentSearch.title : 'Nouvelle recherche') }}
                    <span>Trouvez les annonces rentables de votre secteur</span>
                </h1>
            </div>
            <div class="col-sm-4 col-1">
                <p class="btn btn-outline btn-tool float-right  mobile-icon mt-4" (click)="openTuto()">
                    <img src="assets/icons/yt.png"  class="n-size"alt=""/><span>Tutoriel : Moteur de recherche</span>
                </p>
            </div>
        </div>
        <div [ngClass]="{'hide-content-sidebar' : mode == 'sidebar'}" id="searchForm">
            <!-- Bandeau de la section ouverte : retour aux catégories + nom de la section
                 (masqué en desktop 3 colonnes, où les deux volets sont visibles) -->
            <div class="filters-section-bar">
                <a class="filters-section-back" (click)="mode = 'sidebar'" aria-label="Retour aux filtres">
                    <i class="fa fa-angle-left"></i>
                </a>
                <span class="filters-section-title">{{ getTabLabel() }}</span>
            </div>
            <form [formGroup]="searchForm" (ngSubmit)="search()">
                <div [hidden]="currentTab != 'city'" class="card_tab">

                    <div class="row">
                        <div class="col-12 tabs">
                            <div class="tab {{currentTabLoc == 'city' ? 'active' : ''}} ps-5 pe-5"
                                 (click)="toogleCurrentTabLoc('city')">
                                SECTEUR SIMPLE
                            </div>
                            <div class="tab {{currentTabLoc == 'city_perso' ? 'active' : ''}} ps-5 pe-5"
                                 (click)="toogleCurrentTabLoc('city_perso')"
                                 [stepContent]="filtersCitySaveStepContent"
                                 joyrideStep="filtersCitySaveStep"
                                 (next)="mode = 'sidebar'">
                                SECTEUR AVANCÉ
                            </div>
                        </div>
                        <div *ngIf="currentTabLoc == 'city'" class="col-12 col-md-6"
                             [stepContent]="filtersCityContent"
                             joyrideStep="filtersCityStep"
                             stepPosition="bottom"
                             (prev)="mode = 'sidebar'">
                            <mat-form-field>
                                <mat-label>Ajout d’une ville, département ou région</mat-label>
                                <input type="text" class="text" matInput formControlName="cityControl"
                                       [matAutocomplete]="autoZipcode">
                                <span matPrefix>
                                    <img class="me-2" src="assets/icons/city.svg" alt="" />
                                </span>
                                <mat-autocomplete (optionSelected)='addCity($event.option.value)'
                                                  [displayWith]="commonService.cityLabel" autoActiveFirstOption
                                                  #autoZipcode="matAutocomplete">
                                    <mat-option *ngFor="let city of zipCode" [value]="city">
                                        {{ city.name }}
                                        <ng-container *ngIf="city.type != 'global'">({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }}
                                        )</ng-container>
                                    </mat-option>
                                </mat-autocomplete>
                                <span matSuffix>
                                    <div class="citySpinner">
                                        <mat-spinner diameter="20"></mat-spinner>
                                    </div>
                                </span>
                            </mat-form-field>
                        </div>
                        <!-- Passage à la ligne : les rangées de villes se placent SOUS le champ, même largeur -->
                        <div *ngIf="currentTabLoc == 'city'" class="w-100"></div>
                        <div *ngIf="currentTabLoc == 'city'" class="col-12 col-md-6">
                            <div class="city-wrap">
                                <p *ngFor="let r of region" class="region">
                                    <b class="fs-large me-2"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ r }}</b>
                                    <span class="text-grey">(région)</span>
                                    <i class="fa fa-remove" (click)="removeRegion(r)"></i>
                                </p>
                                <p *ngFor="let d of departement" class="departement">
                                    <b class="fs-large me-2"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ d }}</b>
                                    <span class="text-grey">(département)</span><br/>
                                    <i class="fa fa-remove" (click)="removeDepartement(d)"></i>
                                </p>
                                <p *ngFor="let city of cities">
                                    <b class="fs-large me-2"><i class="fa fa-map-marker"
                                                                aria-hidden="true"></i> {{ city.name }}</b>
                                    <span *ngIf="city.type != 'global'"
                                        class="text-grey">({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }}
                                        )</span>
                                    <i class="fa fa-remove" (click)="removeCity(city)"></i>
                                    <!-- Rayon autour de la ville : slider (le libellé suit le drag, rechargement au relâchement) -->
                                    <span class="city-km-row d-flex align-items-center">
                                        <span class="km-label">Rayon : {{ city.km || 0 }} km</span>
                                        <ngx-slider [value]="city.km || 0" [options]="kmSliderOptions"
                                                    (valueChange)="city.km = $event"
                                                    (userChangeEnd)="city.km = $event.value; loadCities()"></ngx-slider>
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div *ngIf="currentTabLoc == 'city'" class="col-12 text-center text-grey mt-4">
                            <ng-container class="col-12 text-center text-grey mb-2"
                                          *ngIf="citiesCount != null && citiesCount < 1000">
                                Votre recherche comporte {{ citiesCount }} ville{{ citiesCount > 1 ? 's' : '' }}
                            </ng-container>
                            <ng-container class="col-12 text-center text-grey mb-2"
                                          *ngIf="citiesCount != null && citiesCount >= 1000">
                                Votre recherche comporte + de 1000 villes
                            </ng-container>
                        </div>

                        <div *ngIf="currentTabLoc == 'city_perso'" class="col-12 col-md-6">
                            <mat-form-field class="d-none d-lg-block" [stepContent]="filtersCitySaveListStepContent"
                                            joyrideStep="filtersCitySaveListStep">
                                <mat-label>Sélectionner un secteur enregistré</mat-label>
                                <mat-select disableOptionCentering formControlName="search_city_params_id"
                                            [disabled]="userSearchsCity.length == 0 || !authenticationService.isAllowed('essentiel')"
                                            placeholder="Mes villes enregistrées">
                                    <mat-option [value]="0">Sélectionner un secteur enregistré</mat-option>
                                    <mat-option *ngFor="let s of userSearchsCity"
                                                [value]="s.id">{{ s.title }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- MOBILE : sélecteur au format popup (comme le sélecteur de liste des favoris) -->
                            <div class="d-lg-none">
                                <button #cityListBtn class="btn btn-list-selector" type="button"
                                        [matMenuTriggerFor]="cityListMenu" #cityListTrigger="matMenuTrigger"
                                        (click)="cityListSearchText = ''"
                                        [disabled]="userSearchsCity.length == 0 || !authenticationService.isAllowed('essentiel')">
                                    {{ getCityParamsLabel() }}
                                    <i class="fa fa-chevron-down"></i>
                                </button>
                                <mat-menu #cityListMenu="matMenu" class="list-selector-menu mobile-sheet" backdropClass="mobile-sheet-backdrop">
                                    <div class="list-menu-content" [style.min-width.px]="cityListBtn.offsetWidth"
                                         (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                                        <div class="list-menu-search">
                                            <i class="fa fa-search"></i>
                                            <input type="text" placeholder="Rechercher..."
                                                   [(ngModel)]="cityListSearchText" [ngModelOptions]="{standalone: true}">
                                        </div>
                                        <div class="list-menu-items">
                                            <a class="list-menu-item"
                                               [class.active]="!searchForm.get('search_city_params_id').value || '' + searchForm.get('search_city_params_id').value === '0'"
                                               (click)="searchForm.get('search_city_params_id').setValue(0); cityListTrigger.closeMenu()">
                                                Sélectionner un secteur enregistré
                                            </a>
                                            <a *ngFor="let s of filteredUserSearchsCity"
                                               class="list-menu-item"
                                               [class.active]="'' + s.id === '' + searchForm.get('search_city_params_id').value"
                                               (click)="searchForm.get('search_city_params_id').setValue(s.id); cityListTrigger.closeMenu()">
                                                {{ s.title }}
                                            </a>
                                        </div>
                                        <div class="list-menu-footer">
                                            <button class="btn btn-outline w-100" type="button"
                                                    (click)="cityListTrigger.closeMenu(); createSecteur()">
                                                + Nouveau secteur
                                            </button>
                                        </div>
                                    </div>
                                </mat-menu>
                            </div>
                        </div>
                        <div *ngIf="currentTabLoc == 'city_perso'" class="col-12">
                            <div class="row">
                                <div class="col-12 col-md-6 mt-2 mt-lg-5 secteur-avance-hint">
                                    <p>Vous voulez créer un secteur de recherche avec des critères avancés ?
                                        <a class="link" (click)="createSecteur()">
                                            Cliquez ici
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="currentTabLoc == 'city_perso'" class="col-12 col-md-9">
                            <div class="card">
                                <b class="mb-2">Qu’est ce qu’un secteur de recherche personnalisé ?</b>
                                <p>
                                    Vous pouvez créer et enregistrer une liste de villes qui correspondent à vos
                                    critères, en utilisant des filtres sociodémographique et immobilier.
                                    Vous pourrez ensuite chercher des annonces immobilières dans cette liste de ville.
                                </p>
                                <p>
                                    Exemple : Vous habitez à Bordeaux et vous cherchez dans un rayon de 100 km autour de
                                    la ville.
                                    Vous pourrez sélectionner les villes avec plus de 10.000 habitants, un prix au m²
                                    inférieur à 2.000€/m², un rendement moyen de plus de 6%, une démographie en hausse,
                                    des prix de l’immobilier en hausse...
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'type'" class="card_tab">
                    <div class="row">
                        <div class="col-12">
                            <h2>Type de bien</h2>
                        </div>

                        <!-- Sélection en liste (icônes + span.check du site) — mobile et desktop -->
                        <div class="col-12 type-menu-check">
                            <a class="type-option" [class.active]="types.includes('maison')" (click)="toogleType('maison')">
                                <span class="type-option-label">Maison</span>
                                <span class="check"><i class="fa fa-check"></i></span>
                            </a>
                            <a class="type-option" [class.active]="types.includes('appartement')" (click)="toogleType('appartement')">
                                <span class="type-option-label">Appartement</span>
                                <span class="check"><i class="fa fa-check"></i></span>
                            </a>
                            <a class="type-option" [class.active]="types.includes('parking')" (click)="toogleType('parking')">
                                <span class="type-option-label">Garage</span>
                                <span class="check"><i class="fa fa-check"></i></span>
                            </a>
                            <a class="type-option" [class.active]="types.includes('immeuble')" (click)="toogleType('immeuble')">
                                <span class="type-option-label">Immeuble</span>
                                <span class="check"><i class="fa fa-check"></i></span>
                            </a>
                            <ng-container *ngIf="types.includes('immeuble')">
                                <a class="type-option sub-type" [class.active]="searchForm.get('maison_divisible').value == true"
                                   (click)="searchForm.get('maison_divisible').setValue(searchForm.get('maison_divisible').value != true)">
                                    <span class="type-option-label">Inclure les maisons à diviser</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option sub-type" [class.active]="other.includes('exclude_local_commercial')"
                                   (click)="toogleOther('exclude_local_commercial')">
                                    <span class="type-option-label">Exclure les locaux commerciaux</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </ng-container>
                            <a class="type-option" [class.active]="types.includes('terrain')" (click)="toogleType('terrain')">
                                <span class="type-option-label">Terrain</span>
                                <span class="check"><i class="fa fa-check"></i></span>
                            </a>
                            <a class="type-option" [class.active]="types.includes('commerce-fonddecommerce')"
                               [class.lock]="!authenticationService.isAllowed('expert')"
                               (click)="toogleType('commerce-fonddecommerce')">
                                <span class="type-option-label">
                                    Commerce
                                    <ng-container *ngIf="!authenticationService.isAllowed('expert')"> (Plan expert)</ng-container>
                                </span>
                                <span class="check"><i class="fa fa-check"></i></span>
                            </a>
                            <ng-container *ngIf="types.includes('commerce-fonddecommerce')">
                                <a class="type-option sub-type" [class.active]="types.includes('commerce')" (click)="toogleType('commerce')">
                                    <span class="type-option-label">Commerce</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option sub-type" [class.active]="types.includes('fondsdecommerce')" (click)="toogleType('fondsdecommerce')">
                                    <span class="type-option-label">Fond de commerce</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </ng-container>
                            <a class="type-option" [class.active]="types.includes('autre')" (click)="toogleType('autre')">
                                <span class="type-option-label">Autre</span>
                                <span class="check"><i class="fa fa-check"></i></span>
                            </a>
                        </div>

                    </div>
                </div>

                <ng-template #typeExtrasTpl>
                        <div class="col-12"
                             *ngIf="types && (types.includes('immeuble') || types.includes('parking') || types.includes('autre'))">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Nombre de lots
                                    </h2>
                                    <div class="row">
                                        <div class="col-6 pe-0">
                                            <mat-form-field>
                                                <mat-label>Min</mat-label>
                                                <input type="number" step="1" min="0" matInput
                                                       formControlName="nb_lots_min">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-6">
                                            <mat-form-field>
                                                <mat-label>Max</mat-label>
                                                <input type="number" step="1" min="0" matInput
                                                       formControlName="nb_lots_max">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12">
                                            <p class="text-grey fs-small mb-0">
                                                Permet de filtrer les annonces avec plusieurs lots comme un immeuble
                                                de 3 appartements, lot de 5 garages ...
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <h2>Type de vente</h2>
                            <div class="type-menu-check">
                                <a class="type-option" [class.active]="categories && categories.includes('ventes')" (click)="toogleCategory('ventes')">
                                    <span class="type-option-label">Vente immobilière</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="categories && categories.includes('viager')" (click)="toogleCategory('viager')">
                                    <span class="type-option-label">Viager</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="categories && categories.includes('enchere')" (click)="toogleCategory('enchere')">
                                    <span class="type-option-label">Enchère</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="categories && categories.includes('residence')" (click)="toogleCategory('residence')">
                                    <span class="type-option-label">Résidence gérée (Étudiant, EHPAD ...)</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>

                        <div class="col-lg-6 col-12">
                            <h2>
                                Type de bien
                            </h2>
                            <div class="type-menu-check">
                                <a class="type-option" [class.active]="estate_sale && estate_sale.includes('neuf')" (click)="toogleEstateSale('neuf')">
                                    <span class="type-option-label">Neuf</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="estate_sale && estate_sale.includes('ancien')" (click)="toogleEstateSale('ancien')">
                                    <span class="type-option-label">Ancien</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-6 col-12">
                            <h2>
                                Type de vendeur
                            </h2>
                            <div class="type-menu-check">
                                <a class="type-option" [class.active]="owner_type && owner_type.includes('pro')" (click)="toogleOwnerType('pro')">
                                    <span class="type-option-label">Professionnel</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="owner_type && owner_type.includes('private')" (click)="toogleOwnerType('private')">
                                    <span class="type-option-label">Particulier</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>
                </ng-template>

                <div [hidden]="currentTab != 'square'" class="card_tab">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <h2>Surface du bien</h2>
                            <div class="row" *ngIf="currentSearch">
                                <div class="col-6 pe-0">
                                    <mat-form-field>
                                        <mat-label>Min</mat-label>
                                        <input matInput type="number" step="10"
                                               [(ngModel)]="currentSearch.search_ad_params.surface[0]"
                                               [ngModelOptions]="{standalone: true}"
                                        >
                                        <span matSuffix> m²</span>
                                    </mat-form-field>
                                </div>
                                <div class="col-6">
                                    <mat-form-field>
                                        <mat-label>Max</mat-label>
                                        <input matInput type="number" step="10"
                                               [(ngModel)]="currentSearch.search_ad_params.surface[1]"
                                               [ngModelOptions]="{standalone: true}"
                                        >
                                        <span matSuffix> m²</span>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>Surface du terrain</h2>
                            <div class="row" *ngIf="currentSearch">
                                <div class="col-6 pe-0">
                                    <mat-form-field>
                                        <mat-label>Min</mat-label>
                                        <input matInput type="number" step="100"
                                               [(ngModel)]="currentSearch.search_ad_params.surface_land[0]"
                                               [ngModelOptions]="{standalone: true}"
                                        >
                                        <span matSuffix> m²</span>
                                    </mat-form-field>
                                </div>
                                <div class="col-6">
                                    <mat-form-field>
                                        <mat-label>Max</mat-label>
                                        <input matInput type="number" step="100"
                                               [(ngModel)]="currentSearch.search_ad_params.surface_land[1]"
                                               [ngModelOptions]="{standalone: true}"
                                        >
                                        <span matSuffix> m²</span>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>Nombre de pièces</h2>
                    <ul class="nav nav-tabs search-small-type">
                                <li class="nav-item col-2" matTooltipClass="tooltip-button"
                                    matTooltip="Non communiqué">
                                    <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(0)}"
                                       (click)="toogleRooms(0)">
                                        NC
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(1)}"
                                       (click)="toogleRooms(1)">
                                        1
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(2)}"
                                       (click)="toogleRooms(2)">
                                        2
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(3)}"
                                       (click)="toogleRooms(3)">
                                        3
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(4)}"
                                       (click)="toogleRooms(4)">
                                        4
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': rooms && rooms.includes(5)}"
                                       (click)="toogleRooms(5)">
                                        5 et +
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>Étage</h2>
                            <ul class="nav nav-tabs search-small-type search-floor">
                                <li class="nav-item col-2" matTooltipClass="tooltip-button"
                                    matTooltip="Non communiqué">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('nc')}"
                                       (click)="toogleFloor('nc')">
                                        NC
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('rdc')}"
                                       (click)="toogleFloor('rdc')">
                                        RDC
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('1')}"
                                       (click)="toogleFloor('1')">
                                        1er
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('2plus')}"
                                       (click)="toogleFloor('2plus')">
                                        2 et +
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                                <li class="nav-item col-2">
                                    <a [ngClass]="{'nav-link': true, 'active': floor && floor.includes('_Last')}"
                                       (click)="toogleFloor('_Last')">
                                        Dernier
                                        <span class="check"><i class="fa fa-check"></i></span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="col-12">
                            <h2>Atouts du bien</h2>
                            <div class="type-menu-check">
                                <a class="type-option" [class.active]="assets && assets.includes('outside')"
                                   (click)="toogleAssets('outside')">
                                    <span class="type-option-label">Extérieur</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="assets && assets.includes('parking')"
                                   (click)="toogleAssets('parking')">
                                    <span class="type-option-label">Parking</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="assets && assets.includes('elevator')"
                                   (click)="toogleAssets('elevator')">
                                    <span class="type-option-label">Ascenseur</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>

                <div [hidden]="currentTab != 'invest'" class="card_tab">
                    <!-- Paire de champs Min / Max (mobile et desktop : mêmes champs) -->
                    <ng-template #rangeInputsTpl let-control="control" let-suffix="suffix" let-locked="locked">
                        <div class="row" [class.range-locked]="locked" (click)="locked && unlock()">
                            <div class="col-6 pe-0">
                                <mat-form-field>
                                    <mat-label>Min</mat-label>
                                    <input matInput type="number" [ngModel]="getRangeBoundDisplay(control, 0)"
                                           [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="setRangeBound(control, 0, $event)" [disabled]="locked">
                                    <span matSuffix> {{ suffix }}</span>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field>
                                    <mat-label>Max</mat-label>
                                    <input matInput type="number" [ngModel]="getRangeBoundDisplay(control, 1)"
                                           [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="setRangeBound(control, 1, $event)" [disabled]="locked">
                                    <span matSuffix> {{ suffix }}</span>
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-template>
                    <div class="row">
                        <div class="col-md-6 col-12"
                             [stepContent]="filtersSquarePriceContent"
                             joyrideStep="filtersSquarePriceStep"
                             (prev)="mode = 'sidebar'">

                            <h2>
                                Prix au m²
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsSquarePrice.disabled"></i>
                            </h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'squarePrice', suffix: '€/m²', locked: optionsSquarePrice.disabled}"></ng-container>
                        </div>
                        <div class="col-md-6 col-12"
                             [stepContent]="filtersDiffContent"
                             joyrideStep="filtersDiffStep">

                            <h2>Différence prix au m²
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsDiff.disabled"></i></h2>
                            <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'squarePriceDiff', suffix: '%', locked: optionsDiff.disabled}"></ng-container>
                        </div>
                        <div class="col-12"
                             [stepContent]="filtersRendementContent"
                             joyrideStep="filtersRendementStep"
                             (prev)="currentTab = 'invest'"
                             (next)="currentTab = 'advance'">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <h2>Rendement brut
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsRendement.disabled"></i></h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'rendement', suffix: '%', locked: optionsRendement.disabled}"></ng-container>
                                </div>
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Cash-flow
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsCashflow.disabled"></i>
                                    </h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'cashflow', suffix: '€', locked: optionsCashflow.disabled}"></ng-container>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Baisse de prix (en %)
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsPriceChangePercent.disabled"></i>
                                    </h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'price_change_percent', suffix: '%', locked: optionsPriceChangePercent.disabled}"></ng-container>
                                </div>
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Baisse de prix (en €)
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsPriceChangeEuro.disabled"></i>
                                    </h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'price_change_euro', suffix: '€', locked: optionsPriceChangeEuro.disabled}"></ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <h2>
                                        Charge de copropriété annuelle
                                        <i class="fa fa-lock" (click)="unlock()"
                                           *ngIf="optionsAmountCopro.disabled"></i>
                                    </h2>
                                    <ng-container *ngTemplateOutlet="rangeInputsTpl; context: {control: 'amount_copro', suffix: '€', locked: optionsAmountCopro.disabled}"></ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'advance'" class="card_tab">
                    <div class="row">
                        <!-- Nombre de lots, type de vente, neuf/ancien, vendeur
                             (déplacés depuis « Type de bien », qui ne garde que la typologie) -->
                        <div class="col-12">
                            <div class="row">
                                <ng-container *ngTemplateOutlet="typeExtrasTpl"></ng-container>
                            </div>
                        </div>
                        <div class="col-md-6 col-12"
                             [stepContent]="filtersDPEContent"
                             joyrideStep="filtersDPEStep"
                             (prev)="currentTab = 'invest'">
                            <h2>
                                DPE
                            </h2>
                            <!-- Échelle DPE (barres colorées façon étiquette énergie) — mobile et desktop -->
                            <div class="dpe-scale">
                                <a class="dpe-row" [class.active]="dpe && dpe.includes(1)" (click)="toogleDpe(1)">
                                    <span class="check"><i class="fa fa-check"></i></span>
                                    <span class="dpe-track"><span class="dpe-bar dpe-bar-a">A</span></span>
                                </a>
                                <a class="dpe-row" [class.active]="dpe && dpe.includes(2)" (click)="toogleDpe(2)">
                                    <span class="check"><i class="fa fa-check"></i></span>
                                    <span class="dpe-track"><span class="dpe-bar dpe-bar-b">B</span></span>
                                </a>
                                <a class="dpe-row" [class.active]="dpe && dpe.includes(3)" (click)="toogleDpe(3)">
                                    <span class="check"><i class="fa fa-check"></i></span>
                                    <span class="dpe-track"><span class="dpe-bar dpe-bar-c">C</span></span>
                                </a>
                                <a class="dpe-row" [class.active]="dpe && dpe.includes(4)" (click)="toogleDpe(4)">
                                    <span class="check"><i class="fa fa-check"></i></span>
                                    <span class="dpe-track"><span class="dpe-bar dpe-bar-d">D</span></span>
                                </a>
                                <a class="dpe-row" [class.active]="dpe && dpe.includes(5)" (click)="toogleDpe(5)">
                                    <span class="check"><i class="fa fa-check"></i></span>
                                    <span class="dpe-track"><span class="dpe-bar dpe-bar-e">E</span></span>
                                </a>
                                <a class="dpe-row" [class.active]="dpe && dpe.includes(6)" (click)="toogleDpe(6)">
                                    <span class="check"><i class="fa fa-check"></i></span>
                                    <span class="dpe-track"><span class="dpe-bar dpe-bar-f">F</span></span>
                                </a>
                                <a class="dpe-row" [class.active]="dpe && dpe.includes(7)" (click)="toogleDpe(7)">
                                    <span class="check"><i class="fa fa-check"></i></span>
                                    <span class="dpe-track"><span class="dpe-bar dpe-bar-g">G</span></span>
                                </a>
                            </div>
                            <!-- Biens sans DPE (NC) en case à cocher -->
                            <div class="type-menu-check">
                                <a class="type-option" [class.active]="dpe && dpe.includes(0)" (click)="toogleDpe(0)">
                                    <span class="type-option-label">Inclure les biens sans DPE</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-6 col-12"
                             [stepContent]="filtersMonthContent"
                             joyrideStep="filtersMonthStep"
                             (next)="mode = 'sidebar'">
                            <h2>
                                Ancienneté de l'annonce
                                <i class="fa fa-lock" (click)="unlock()"
                                   *ngIf="optionsMonth.disabled"></i>
                            </h2>
                            <!-- Valeurs Min / Max : select classique, sur le même contrôle que le slider -->
                            <div class="row g-2">
                                <div class="col-6">
                                    <mat-form-field>
                                        <mat-label>Min</mat-label>
                                        <mat-select disableOptionCentering [ngModel]="getMonthBound(0)"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="onMonthSelect(0, $event)"
                                                    [disabled]="optionsMonth.disabled">
                                            <mat-option *ngFor="let m of monthMinOptions" [value]="m.value">{{ m.label }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-6">
                                    <mat-form-field>
                                        <mat-label>Max</mat-label>
                                        <mat-select disableOptionCentering [ngModel]="getMonthBound(1)"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (ngModelChange)="onMonthSelect(1, $event)"
                                                    [disabled]="optionsMonth.disabled">
                                            <mat-option *ngFor="let m of monthMaxOptions" [value]="m.value">{{ m.label }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-6 col-12">
                            <h2>
                                Travaux
                            </h2>
                            <div class="type-menu-check">
                                <a class="type-option" [class.active]="work && work.includes('nc')" (click)="toogleWork('nc')">
                                    <span class="type-option-label">Inconnu</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="work && work.includes('work')" (click)="toogleWork('work')">
                                    <span class="type-option-label">Avec travaux</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="work && work.includes('renov')" (click)="toogleWork('renov')">
                                    <span class="type-option-label">Sans travaux</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>
                                Locataire en place
                            </h2>
                            <div class="type-menu-check">
                                <a class="type-option" [class.active]="rent && rent.includes(0)" (click)="toogleRent(0)">
                                    <span class="type-option-label">Non</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="rent && rent.includes(1)" (click)="toogleRent(1)">
                                    <span class="type-option-label">Oui</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <h2>
                                Divers
                            </h2>
                            <div class="type-menu-check">
                                <a class="type-option" [class.active]="other && other.includes('exclude_copro')" (click)="toogleOther('exclude_copro')">
                                    <span class="type-option-label">Exclure les biens en copropriété</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="other && other.includes('exclude_local_commercial')" (click)="toogleOther('exclude_local_commercial')">
                                    <span class="type-option-label">Exclure les locaux commerciaux</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="other && other.includes('no_pictures')" (click)="toogleOther('no_pictures')">
                                    <span class="type-option-label">Sans photos uniquement</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="other && other.includes('urgent')" (click)="toogleOther('urgent')">
                                    <span class="type-option-label">Vente urgente uniquement</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="other && other.includes('offmarket')" (click)="toogleOther('offmarket')">
                                    <span class="type-option-label">Bien off-market uniquement</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="searchForm.get('opened').value == true"
                                   (click)="searchForm.get('opened').setValue(searchForm.get('opened').value != true)">
                                    <span class="type-option-label">Exclure les annonces déjà ouvertes</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                                <a class="type-option" [class.active]="searchForm.get('exclude_hidden').value == true"
                                   (click)="searchForm.get('exclude_hidden').setValue(searchForm.get('exclude_hidden').value != true)">
                                    <span class="type-option-label">Exclure les annonces masquées</span>
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div [hidden]="currentTab != 'text'" class="card_tab">
                    <div class="row">
                        <div class="col-12">
                            <h2>Recherche par mots clés</h2>
                        </div>
                        <div class="col-md-6 col-12">
                            <mat-form-field>
                                <mat-label>Mots clés</mat-label>
                                <input type="text" class="text" matInput formControlName="search" data-live-on-enter>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6 col-12">
                            <mat-checkbox formControlName="search_title" class="mt-0 mt-md-3">
                                Recherche dans le titre uniquement
                            </mat-checkbox>
                        </div>
                        <div class="col-12">
                            <div class="card search-tips mt-3">
                                <b class="mb-2">Quelques astuces pour votre recherche :</b>
                                <!-- https://www.elastic.co/fr/blog/leviers-elasticsearch-pour-le-traitement-des-specificites-linguistiques -->
                                <ul>
                                    <li class="mb-1">Lorsque vous faites une recherche par mots clés, privilégiez le
                                        singulier avec une * à la fin : immeuble* pour rechercher tous les mots qui
                                        commencent par immeuble. Ainsi l'outil recherchera aussi bien immeubles et
                                        immeuble.<br/>
                                        Pour division, si vous recherchez divi* vous aurez tous les mots : diviser,
                                        division, divisable ...
                                    </li>
                                    <li class="mb-1">Si vous souhaitez faire une recherche sur plusieurs mots, il
                                        est important d'utiliser les guillemets : "terrain constructible". Si vous
                                        recherchez sans les guillemets, l'outil affichera les annonces avec
                                        "terrain" OR "constructible".
                                    </li>
                                    <li class="mb-1">Si vous souhaitez faire une recherche en excluant certains termes,
                                        vous
                                        pouvez utiliser NOT. Exemple "hotel" NOT "particulier"
                                    </li>
                                    <li class="mb-1">
                                        Si vous souhaitez faire une recherche sur les biens avec ou sans travaux,
                                        utiliser le filtre présent dans "Critères avancés".<br/>
                                        Il comporte plus de 40 cas pour avoir un filtre très optimisé.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Effacer (la section, on y reste) / Valider (retour aux catégories), barre fixe en bas -->
                <div class="container-fluid filters-actions">
                    <div class="d-flex justify-content-between gap-3">
                        <button class="btn btn-lg btn-outline" type="button" (click)="resetCurrentTab()">
                            <i class="fa fa-refresh"></i> Effacer
                        </button>
                        <button class="btn btn-lg" type="button" (click)="mode = 'sidebar'">
                            <i class="fa fa-check"></i> Valider
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<ng-template #filtersStepContent>
    <div class="user_onboarding_content">
        <h2>Définissez vos critères</h2>
        <p>
            C’est ici que vous allez construire votre <b>recherche de bien rentable.</b><br/>
            <br/>
            Vous pouvez naviguer dans le menu de gauche pour définir vos <b>critères de recherche.</b><br/>
            <br/>
            Faisons le tour ensemble !
        </p>
    </div>
</ng-template>

<ng-template #filtersCityContent>
    <div class="user_onboarding_content">
        <h2>Localisation</h2>
        <p>
            Pour commencer, choisissez votre secteur de recherche.<br/>
            <br/>
            Vous pouvez renseigner une <b>ville</b>, un <b>département</b>, et même une <b>région</b>.<br/>
            <br/>
            <b>Astuce</b> : Vous pouvez définir un rayon jusqu’à <b>100 km autour d’une ville</b> !
            <br/>
        </p>
    </div>
</ng-template>

<ng-template #filtersCitySaveStepContent>
    <div class="user_onboarding_content">
        <h2>Secteur de recherche personnalisé</h2>
        <p>
            L’application LyBox dispose d’un <b>module</b> entier pour vous aider à <b>trouver les villes à
            potentiel</b>, partout en France.<br/>
            <br/>
            Ce module sera détaillé lors des <b>prochaines étapes</b> pour démarrer avec LyBox.<br/>
            <br/>
            Une fois votre secteur personnalisé créé, vous pourrez le sélectionner ici.
        </p>
    </div>
</ng-template>

<ng-template #filtersTabsContent>
    <div class="user_onboarding_content">
        <h2>Critères de recherche avancés</h2>
        <p>
            Nous allons nous intéresser aux filtres que <b>vous ne trouverez pas sur les sites immobiliers
            classiques.</b><br/>
            <br/>
            En tant qu’investisseur immobilier, une bonne utilisation de ces filtres vous permettra d’être plus
            efficaces et de <b>doubler les autres investisseurs</b> !
        </p>
    </div>
</ng-template>

<ng-template #filtersSquarePriceContent>
    <div class="user_onboarding_content">
        <h2>Prix au m² des annonces</h2>
        <p>
            Sélectionner un minimum et un maximum <b>de prix au m²</b> pour ne faire ressortir que les meilleures
            annonces.
        </p>
    </div>
</ng-template>

<ng-template #filtersRendementContent>
    <div class="user_onboarding_content">
        <h2>Rendement locatif brut</h2>
        <p>
            Filtrer sur les annonces avec un fort <b>rendement locatif</b> et générant du <b>cash-flow</b>
        </p>
    </div>
</ng-template>

<ng-template #filtersDiffContent>
    <div class="user_onboarding_content">
        <h2>Différence de prix par rapport au marché local</h2>
        <p>
            <b>Encore mieux</b> : vous pouvez choisir de ne voir que les annonces <b>sous le prix du marché</b>. Très
            utile si vous cherchez dans plusieurs villes différentes.<br/>
            <br/>
            <b>Exemple</b> : Vous cherchez dans une ville “A” ou le prix moyen est de 3.000€/m², mais aussi dans une
            ville “B” ou le prix moyen est de 2.000€/m².<br/>
            <br/>
            Vous pouvez régler le curseur sur -10% pour ne voir que les annonces qui :
        </p>
        <ul>
            <li>Sont à moins de 2.700€/m² dans la ville “A”</li>
            <li>Sont à moins de 1.800€/m² dans la ville “B”</li>
        </ul>
        <p>
            Pas mal, non?
        </p>
    </div>
</ng-template>

<ng-template #filtersDPEContent>
    <div class="user_onboarding_content">
        <h2>Diagnostic de performance énergétique</h2>
        <p>
            Le DPE est devenu un vrai enjeu pour les investisseurs depuis la <b>Loi Climat</b>.<br/>
            <br/>
            Vous pouvez par exemple filtrer sur les <b>passoires énergétiques</b> (F et G) et tenter de fortes
            négociations !
        </p>
    </div>
</ng-template>

<ng-template #filtersMonthContent>
    <div class="user_onboarding_content">
        <h2>Ancienneté de l’annonce</h2>
        <p>
            Grâce à ce filtre, vous pouvez vous concentrer sur <b>les biens en vente depuis plusieurs mois</b>.<br/>
            <br/>
            LyBox est capable de détecter les <b>annonces supprimées puis repostées</b>, et vous affiche toujours <b>la
            première date de publication</b>.<br/>
            <br/>
            L’application est aussi capable de détecter les <b>baisses de prix</b>.<br/>
            <br/>
            Mais ça, c’est pour la suite 😉
        </p>
    </div>
</ng-template>

<ng-template #filtersValidateContent>
    <div class="user_onboarding_content">
        <h2>Valider votre recherche</h2>
        <p>
            Cliquez ici pour accéder aux résultats de recherche.<br/>
            <br/>
            Vous pourrez <b>enregistrer</b> vos critères de recherche sur le prochain écran.
        </p>
    </div>
</ng-template>

<ng-template #filtersCitySaveListStepContent>
    <div class="user_onboarding_content">
        <h2>Vos secteurs de recherche</h2>
        <p>
            Retrouvez ici la liste de vos secteurs de recherche pour les utiliser dans vos recherches de biens.
        </p>
    </div>
</ng-template>
